import { JSONSchemaProp, TAddress, TAddressType } from 'models';
import { translateEnumItemInScheme } from 'utils';
import { getAddedTypes } from './index';

export const setAddressTypeOptions = (options: TAddressType[], addresses: TAddress[], prop: JSONSchemaProp) => {
  const addedTypes = getAddedTypes(addresses);
  const availableOptions = !!options?.length ? options.filter(o => !addedTypes.includes(o)) : [];

  return availableOptions.map(item => ({
    key: item,
    value: translateEnumItemInScheme(prop, item)
  }));
};
